export enum CalendarProvider {
  GOOGLE = 'GOOGLE',
  MICROSOFT = 'MICROSOFT',
  VIRTUAL_CALENDAR = 'VIRTUAL_CALENDAR',
  NONE = 'NONE',
}

export function isVirtualCalendarProvider(
  provider: string | null | undefined
): boolean {
  return (
    provider === CalendarProvider.VIRTUAL_CALENDAR ||
    provider === 'virtual_calendar'
  );
}
